// extracted by mini-css-extract-plugin
export default {"LoginPage":"LoginPage_LoginPage__pnmH6"};